export default {
  black: '#000',
  black20: 'rgba(0, 0, 0, 0.2)',
  black40: 'rgba(0, 0, 0, 0.4)',
  black50: 'rgba(0, 0, 0, 0.5)',
  black60: 'rgba(0, 0, 0, 0.6)',
  black80: 'rgba(0, 0, 0, 0.8)',

  itemActive: '#d62300',
  itemInactive: '#502314',

  primary: '#d62300',
  background: '#f5ebdc',

  white: '#fff'
};
